import React from 'react'
import classes from './NewsCard.module.css'
import { Link } from 'gatsby'
import { getImage } from '../../utils/getImage'

export const NewsCard = ({ isHeading, info }) => (
  <Link
    to={(isHeading ? '/heading/' : '/news/') + info?.id}
    style={{
      textDecoration: 'none',
    }}
  >
    <div
      className={
        isHeading ? classes.card_heading__wrapper : classes.card_news__wrapper
      }
    >
      <img className={classes.image} src={getImage(info?.images[0])} />
      <div className={classes.card__text}>
        <h2 className={classes.title}>{info.theme}</h2>
        {info?.description && (
          <p className={classes.description}>{info.description}</p>
        )}
      </div>
    </div>
  </Link>
)
